import { render } from "./DeleteProductModal.vue?vue&type=template&id=1f21c53c"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__